import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as productionWIPSelectors, actions as productionWIPActions } from 'ducks/inventoryEnquiry/stocking/productionWIP';
import { search } from 'api/inventoryEnquiry/stocking/productionWIP';
const params = () => (new URLSearchParams(location.search));

export const mapStateToProps = state => ({
  gridName: 'IEStockingQuantitiesProductionWIP',
  columnDefs: productionWIPSelectors.columns(state),
  rowData: productionWIPSelectors.data(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: productionWIPSelectors.gridOptions(state),
  isLoading: productionWIPSelectors.isLoading(state),
  reqParams: (productionWIPSelectors.selected(state) || params().get('ProductId') || params().get('Warehouse'))
    &&
  {
    ProductId: (productionWIPSelectors.selected(state) && productionWIPSelectors.selected(state).ProductId) || params().get('ProductId'),
    Warehouse: (productionWIPSelectors.selected(state) && productionWIPSelectors.selected(state).Warehouse) || params().get('Warehouse')
  },
  apiMethod: search
})

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: productionWIPActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
}
